import { useEffect } from 'react';
import PageLayout from '../components/PageLayout';
import EcosystemSection from '../components/EcosystemSection';

const Ecosystem = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <PageLayout title="Ecosystem">
      <EcosystemSection />
    </PageLayout>
  );
};

export default Ecosystem;
